import { render, staticRenderFns } from "./tabs-card-roller.vue?vue&type=template&id=6d0d459e&"
import script from "./tabs-card-roller.vue?vue&type=script&lang=js&"
export * from "./tabs-card-roller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports